import { PeriodPlan } from '@/optimizer/periodPlan.type';
import { normalizePeriodDate } from '@/optimizer/helpers/periodPlanUtils';
import { OptimizedPlans } from '@analytical-alley/opt-wasm/optimizer/optimizer.interface';
import { getColumn, getColumnNames, vectorToArray } from '@analytical-alley/opt-wasm';
import moment from 'moment';

export const modifyDailyPlan = (plan: OptimizedPlans, medias: string[]) => {
    const table = plan.optimizedPlan;
    const periodNames = vectorToArray(getColumn(table, 'Period name'));
    
    const result: PeriodPlan[] = [];
    
    for (let i = 0; i < table.numRows; i++) {
        const row: any = {
            periodIndex:
                normalizePeriodDate(periodNames[i]) ??
                moment(periodNames[i]).format('YYYY-MM-DD'),
        };
        
        medias.forEach(media => {
            try {
                const col = getColumn(table, media);
                row[media] = col.get(i);
            } catch (e) {
                row[media] = 0;
            }
        });
        
        result.push(row as PeriodPlan);
    }
    
    return result;
};
